import { ErrorMessage } from "formik";
import React, { useState, useMemo } from "react";
import DeleteModel from "../../membership/deleteModel";

function UploadVideo({ value, edit, name, setFieldValue, uploadAction, count, setVideoUploading, vClass = "", pClass = "" }: any) {
  const [upload, setUpload] = useState<number | string | undefined | null>(0);
  const [error, setError] = useState<string>("");

  const checkVideoType = (fileType: any) => {
    const allowedVideoTypes = ["video/mp4", "video/webm", "video/ogg", "video/x-msvideo", "video/quicktime"];
    return allowedVideoTypes.includes(fileType);
  };

  const handleUpload = (event: any, fieldValue: any, name: string) => {
    const selectedFile = event.currentTarget.files[0];
    const isVideo = checkVideoType(selectedFile.type);
    if (isVideo) {
      setError("");
      const data = {
        file: event.currentTarget.files[0],
      };
      uploadAction(data, fieldValue, name, setUpload, setVideoUploading);
    } else {
      setError("Please upload valid video");
    }
  };

  const uploadPercent = useMemo(() => {
    const uploading = `Uploading (${upload}%)`;
    return `${upload ? uploading : "Upload Video"}`;
  }, [upload]);
  return (
    <>
      <div className={`uploarForm position-relative overflow-hidden ${pClass}`}>
        {value ? (
          <>
            {count ? <span className="labelCount position-absolute top-0 start-0 ms-3 mt-3">{count}</span> : null}
            {edit ? <DeleteModel {...{ text: "", onClick: () => setFieldValue(name, "") }} /> : null}
            <div className={`videoView ${vClass}`}>
              <video controls autoPlay src={value} />
            </div>
          </>
        ) : (
          <>
            {count ? <span className="labelCount position-absolute top-0 start-0 ms-3 mt-3">{count}</span> : null}
            <input
              id="file"
              name={name}
              type="file"
              accept="video/mp4,video/x-m4v,video/*"
              onChange={(e) => handleUpload(e, setFieldValue, name)}
              disabled={!!upload || !edit}
            />
            <div className="position-absolute top-50 text-center w-100 translate-middle-y">
              {upload ? <i className="fa-light fa-circle-notch fa-spin fa-2x text-primary" /> : <i className="fa-light fa-upload fa-2x text-primary" />}
              <h6 className="mb-0 mt-3">{uploadPercent}</h6>
            </div>
          </>
        )}
      </div>
      {!error && !upload && <ErrorMessage name={name} className="errorMessage" component="div" />}
      {error && <div className="errorMessage">{error}</div>}
    </>
  );
}

export default UploadVideo;
